import React from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { getTopPortalTarget } from '../utils/portal';
import { componentText } from '../utils/i18n_utils';

const t = (key, fallback, params) => componentText(`cut_line_button.${key}`, fallback, params);

// Confirmation shown before displaying a final_score-projected cut line with
// insufficient scores — the React counterpart of the old fancybox popups in
// app/views/v2tournaments/_first_pop_up_condition.html.haml (option_1) and
// _second_pop_up_condition.html.haml (option_2). Confirming navigates to the
// cut_list_operations_pop_up backend action, like the old popup links.
const CutLineConfirmationModal = ({ button, onClose }) => {
  const isOption2 = button.confirmation === 'option_2';

  const body = isOption2
    ? [
        t('expected_percentage', `All holes must have at least ${button.scorePercentage}% scores recorded.`, { score_percentage: button.scorePercentage }),
        t('current_percentage', `Current percentage is ${button.calculatedPercentage}%`, { percentage: button.calculatedPercentage }),
      ].join(' ')
    : t('cannot_project_cut_line', "Some holes have no scores yet, so we can't project the cut line. You can project it from players' current to-par scores instead, or hide the projection for now.");

  const confirmLabel = isOption2
    ? t('project_average', 'Project cut line using current average on each hole')
    : t('project_to_par', 'Project from to-par scores');

  return createPortal(
    <div className="lbv2__confirmation-overlay" onClick={onClose}>
      <div
        className="lbv2__confirmation-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="lbv2__confirmation-title">
          {t('insufficient_scores', 'Insufficient scores')}
        </div>
        <p className="lbv2__confirmation-text">{body}</p>
        <div className="lbv2__confirmation-actions">
          <a className="lbv2__confirmation-confirm" href={button.confirmHref}>
            {confirmLabel}
          </a>
          <button className="lbv2__confirmation-cancel" onClick={onClose}>
            {t('do_not_display', 'Hide projection')}
          </button>
        </div>
      </div>
    </div>,
    getTopPortalTarget()
  );
};

CutLineConfirmationModal.propTypes = {
  button: PropTypes.shape({
    confirmation: PropTypes.string,
    confirmHref: PropTypes.string,
    scorePercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    calculatedPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CutLineConfirmationModal;
